import { ROUTES } from "@/constants/Routes";
import { ATTRIBUTION_NAMES } from "@/constants/User";
import { hasAttribution } from "@/utils/permissions";
import { useUserStore } from "@/store/useUserStore";
import { Box, Link, Typography } from "@mui/material";
import principles_question from "@/assets/images/principles_question.png";
import Image from "next/image";

export function PrinciplesXQuestions() {
	const canManage = useUserStore(
		({ attributions, isAdmin }) =>
			hasAttribution(attributions ?? [], ATTRIBUTION_NAMES.SOCIO_JURIDICO) || isAdmin
	);

	return (
		<>
			<Typography variant='body2'>
				Perguntas e princípios éticos são vinculados no momento de{" "}
				{canManage ? (
					<Link href={ROUTES.QUESTIONNAIRE.REGISTER.AIA}>
						criação dos questionários AIA
					</Link>
				) : (
					<span style={{ fontWeight: "bold" }}>
						criação dos questionários AIA
					</span>
				)}
				.
			</Typography>

			<Typography variant='body2'>
				Cada pergunta de um questionário AIA recebe pelo menos um princípio
				ético vinculado a aquele questionário.
			</Typography>

			<Box>
				<Image
					height={220}
					placeholder='blur'
					src={principles_question}
					alt='Pergunta com princípios associados'
				/>
				<Typography component={"p"} variant='caption' sx={{ paddingLeft: 0.5 }}>
					Pergunta com princípios vinculados do questionário
				</Typography>
			</Box>

			<Typography variant='body2'>
				Uma pergunta pode receber quaisquer princípios vinculados do
				questionário em criação. Cada princípio ético é utilizado posteriormente
				para fins de cálculo conforme o número das demais perguntas vinculadas e
				resposta do usuário.
			</Typography>
		</>
	);
}
